export default function isStringifiable(value) {
    return (typeof value === 'object' &&
        value !== null &&
        'toString' in value &&
        typeof value.toString === 'function');
}
//# sourceMappingURL=is-stringifiable.js.map